import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';
import { ReassignCaseCommand } from './reassign-case.command';

@Injectable({ providedIn: 'root' })
export class ReassignCaseUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(command: ReassignCaseCommand): Observable<void> {
    return this._repository.singleReassign(command.caseId, {
      newPrimaryUserId: command.newPrimaryUserId,
      reason: command.reason,
    });
  }
}
